module.exports = __webpack_public_path__ + "img/chanyecontactbtn.07c8efd4.png";